import React from 'react';
import { useSelector } from 'react-redux';
import { IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonMenuToggle, IonItem, IonLabel, IonIcon } from '@ionic/react';
import { useHistory } from 'react-router';

// Hooks
import useMenu from '../../hooks/useMenu';

// Constants
import { APP_CONFIG } from '../../constants';

// Helpers
import { hasAccess, isWeb, isMobileWeb, isBranchEnabled, sendEventMenu } from '../../helpers';

export const MenuComponent =
    ({ 
        menuId, 
        contentId, 
        title,
        setInit,
        logout,
        permissions,
        menuRef
    }) => {

    const { gonogo } = useSelector( state => state.app );
    const history = useHistory();

    const items = 
        gonogo.configuration != null && gonogo.configuration !== undefined && gonogo.configuration.MENU !== undefined 
        ? gonogo.configuration.MENU: [];
        
    const componentes = useMenu(items);

    const handleClick = (component) => {

        if (component.redirectTo === APP_CONFIG.LOGOUTREF) {

            logout();
        }
        
        // Analytics
        sendEventMenu(component.analytickAction);

        setInit();
        
        history.push(component.redirectTo);
        
    };

    return (
        <IonMenu side="start" menuId={menuId} contentId={contentId} ref={menuRef}>

            <IonHeader>
                <IonToolbar mode="md" color="primary">
                    <IonTitle>
                        <h1>Bienvenido</h1>
                        {title && <p>{title}</p>}
                    </IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <IonList>
                    {
                        componentes.map(c => {

                            // Si no tiene autorización, no debe mostrar la opción
                            if ( c.permissions && !hasAccess(c.permissions, permissions) ) { return null; }

                            // Si es web y la opción no está disponible para web, no debe mostrar la opción
                            if ( (isWeb() || isMobileWeb()) && !c.enabledInWeb ) { return null; }

                            // Si el branch no está habilitado y no se disponibiliza esta opción, no debe mostrarla
                            if ( !isBranchEnabled() && !c.availableInBranchDisabled ) { return null; }

                            return (
                                <IonMenuToggle key={c.name} autoHide="false">
                                    <IonItem className="pointer" lines="none" onClick={() => {

                                        // Se permite ejecutar la opción del menú, si no está en mantenimiento o si la misma es la de cerrar sesión
                                        if ( !APP_CONFIG.MESSAGE.ALERT?.mainteinment?.enabled || c.redirectTo === APP_CONFIG.LOGOUTREF ) {

                                            handleClick(c);
                                        }

                                    }}>
                                        <IonIcon color="secondary" slot="start" icon={c.icon}></IonIcon>
                                        <IonLabel color="secondary">{c?.name}</IonLabel>
                                    </IonItem>
                                </IonMenuToggle>
                            )
                        })
                    }
                </IonList>


            </IonContent>

        </IonMenu>
    );
};
